import { Leaf } from "lucide-react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ScrollReveal } from "@/hooks/useScrollReveal";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    
    // If we're not on the home page, navigate there first with the hash
    if (location.pathname !== "/") {
      navigate("/" + targetId);
      return;
    }
    
    const element = document.querySelector(targetId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  return (
    <footer className="py-16 border-t border-border">
      <div className="container mx-auto px-6">
        <ScrollReveal animation="fade-up">
          <div className="flex flex-col md:flex-row justify-between gap-12 mb-16">
            <div className="max-w-sm">
              <a 
                href="#" 
                onClick={(e) => {
                  e.preventDefault();
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className="flex items-center gap-2 mb-4 cursor-pointer w-fit"
              >
                <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Leaf className="w-5 h-5 text-primary" />
                </div>
                <span className="text-xl font-semibold">Nutri IA</span>
              </a>
              <p className="text-muted-foreground">
                Automatize seu consultório de nutrição com IA. O futuro da saúde começa aqui.
              </p>
            </div>

            <div className="flex gap-16">
              <div>
                <p className="font-semibold mb-4">Plataforma</p>
                <ul className="space-y-3 text-muted-foreground">
                  <li>
                    <a 
                      href="#funcionalidades" 
                      onClick={(e) => handleSmoothScroll(e, "#funcionalidades")}
                      className="hover:text-foreground transition-colors"
                    >
                      Funcionalidades
                    </a>
                  </li>
                  <li>
                    <a 
                      href="#como-funciona" 
                      onClick={(e) => handleSmoothScroll(e, "#como-funciona")}
                      className="hover:text-foreground transition-colors"
                    >
                      Como Funciona
                    </a>
                  </li>
                  <li>
                    <a 
                      href="#ecossistema" 
                      onClick={(e) => handleSmoothScroll(e, "#ecossistema")}
                      className="hover:text-foreground transition-colors"
                    >
                      Ecossistema
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <p className="font-semibold mb-4">Legal</p>
                <ul className="space-y-3 text-muted-foreground">
                  <li><Link to="/privacidade" className="hover:text-foreground transition-colors">Privacidade</Link></li>
                  <li><Link to="/termos" className="hover:text-foreground transition-colors">Termos</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </ScrollReveal>

        <ScrollReveal animation="fade-up" delay={200}>
          <div className="border-t border-border pt-8">
            <div className="text-center mb-8">
              <a 
                href="#" 
                onClick={(e) => {
                  e.preventDefault();
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className="cursor-pointer"
              >
                <span className="text-5xl md:text-7xl font-display text-gradient font-bold">Nutri IA</span>
              </a>
            </div>
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
              <p>© 2025 Nutri IA. Todos os direitos reservados.</p>
              <p>Desenvolvido por Matheus Batista</p>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </footer>
  );
};

export default Footer;
